<div class="container">
    <div class="split-example form-container" >
        <as-split direction="horizontal" restrictMove="true" [useTransition]="true">
            <as-split-area size="50">
                <as-split direction="vertical" restrictMove="true">
                    <as-split-area>
                        <p class="form-container-ignore">
                            <sprout-forms *ngIf="form" [model]="form" (formValue)="onFormValueChange($event)"></sprout-forms>
                        </p>
                    </as-split-area>
                    <as-split-area>
<!--                        <pre>{{model|json}}</pre>-->
<!--                        <p [innerHTML]="model | prettyJSON"></p>-->
                        <ngx-monaco-editor class="process-builder-editor" [options]="monacoJsonOptions" [(ngModel)]="modelView"></ngx-monaco-editor>
                    </as-split-area>
                </as-split>
            </as-split-area>
            <as-split-area size="50">
                <as-split direction="vertical" restrictMove="true">
                    <as-split-area size="50">
                        <ngx-monaco-editor #handlebarsEditor (onInit)="onInitHandlebarsEditor($event, context)" class="process-builder-editor" [options]="monacoHandlebarsOptions" [(ngModel)]="template"></ngx-monaco-editor>
                    </as-split-area>
                    <as-split-area size="50">
                        <div [innerHTML]="html"></div>
                    </as-split-area>
                </as-split>
            </as-split-area>
        </as-split>
    </div>
</div>